export const EnsureInViewWhenLetterImagesLoaded = {
  mounted() {
    const popup = this.el;
    const page_root = popup.closest(".page-root");

    if (page_root) {
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === page_root) {
            popup.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      });

      observer.observe(page_root);
    }
  }
}
